import * as React from "react";
import { forwardRef } from "react";
const SvgUpload = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 16H7V18.5H17V16H19V20.5H5V16Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M15.59 9.91L17 8.5L12 3.5L7 8.5L8.41 9.91L11 7.33L11 16.5H13L13 7.33L15.59 9.91Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
